export enum ProposalState {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Defeated = 'Defeated',
  Draft = 'Draft',
  Executable = 'Executable',
  ExecutingWithErrors = 'ExecutingWithErrors',
  Finalizing = 'Finalizing',
  SigningOff = 'SigningOff',
  Voting = 'Voting',
}
